import { render, staticRenderFns } from "./MostSales.vue?vue&type=template&id=72052226&scoped=true&"
import script from "./MostSales.vue?vue&type=script&lang=js&"
export * from "./MostSales.vue?vue&type=script&lang=js&"
import style0 from "./MostSales.vue?vue&type=style&index=0&id=72052226&scoped=true&lang=css&"
import style1 from "./MostSales.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72052226",
  null
  
)

export default component.exports